import { Component, ChangeDetectionStrategy, Input, ChangeDetectorRef, TemplateRef } from '@angular/core';
import { PFieldAbstractComponent } from '../p-field-abstract';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import * as _ from 'lodash';

@Component({
    selector: 'p-field-multi-checkbox',
    template: `
        <div fxLayout="row">
            <p-field [isMandatory]="mandatory" [label]="label" [labelTooltip]="labelTooltip" [isReadOnly]="isReadOnly">
                <span slot="readMode" [attr.automation-id]="'p-field-multi-checkbox_' + label">
                    {{ getNames(value) || placeholder }}
                </span>

                <div slot="editMode" class="checkbox-group" [attr.automation-id]="'p-field-multi-checkbox_' + label">
                    <!--[ngStyle]="optionStyle"-->

                    <mat-checkbox
                        *ngFor="let op of list"
                        (change)="changeValue(op, $event.checked)"
                        class="p-checkbox"
                        [ngClass]="{ 'select-all': op.selectAll }"
                        [indeterminate]="op.indeterminate"
                        [checked]="isChecked(op)"
                        [disabled]="isDisabled"
                        [value]="op[idField]"
                    >
                        <ng-container *ngTemplateOutlet="itemTmpl || defaultItemTmpl; context: { $implicit: op }"> </ng-container>
                    </mat-checkbox>

                    <!--
                                        <span *ngFor="let op of list" class="options-group__item">
                                            <input
                                                type="checkbox"
                                                [checked]="isChecked(op.id || op.value || op)"
                                                (change)="changeValue($event)"
                                                [attr.id]="op.id || op.value || op"
                                                [value]="op.id || op.value || op"
                                            />
                                            <label [attr.for]="op.id || op.value || op">{{ op.name || op }}</label>
                                        </span>
                    -->
                </div>
            </p-field>
        </div>

        <ng-template #defaultItemTmpl let-op>
            <label [attr.for]="op[idField]">{{ op[nameField] }}</label>
        </ng-template>
    `,
    styleUrls: ['./p-field-multi-checkbox.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: PFieldMultiCheckboxComponent
        }
    ],

    exportAs: 'pFieldMultiCheckbox'
})
export class PFieldMultiCheckboxComponent<T> extends PFieldAbstractComponent<T[]> {
    @Input() label?: string;
    @Input() mandatory = false;
    // @Input() optionStyle: string;
    @Input() idField: string = 'id';
    @Input() nameField: string = 'name';
    @Input() itemTmpl?: TemplateRef<any>;

    _listMap: any; // array of name, checked
    @Input() set list(values: any[]) {
        this._listMap = _.keyBy(values, this.idField);
        values.forEach((value: any) => this.changeValue(value, value.checked));
    } // array of name, checked
    get list() {
        return _.values(this._listMap);
    }

    @Input() placeholder = '';
    private _valueSet = new Set<T>();

    constructor(cd: ChangeDetectorRef) {
        super(cd);
    }

    getNames(ids: any) {
        return _.map(ids, (id) => this._listMap[id]?.[this.nameField] || id).join(', ');
    }

    override writeValue(obj: T[]) {
        super.writeValue(obj);
        this._valueSet = new Set(obj);
    }

    isChecked(op: any) {
        return this._valueSet.has(op[this.idField]);
    }

    changeValue(op: any, checked: boolean) {
        this.markAsTouched();

        if (!this.isReadOnly) {
            const value = op[this.idField];
            if (!checked) {
                this._valueSet.delete(value);
            } else {
                this._valueSet.add(value);
            }

            this.value = [...this._valueSet];

            this._onChange(this.value);
        }
    }
}
